import React, { useMemo } from 'react';
import { Row, Col, FormGroup, Label } from 'reactstrap';
import Select from 'components/Select';
import { useUpdateSalesLocation } from '../../api/sales-locations/service';
import { getActiveColorStyle } from 'utils/colorUtils';
import { getTheme2FormPageDarkSelectStyles } from 'utils/theme2MultiSelect';

const InventoryDefaults = ({ formData, setFormData, activeColor = "blue", isTheme2 = false, inventoryStatusOptions, salesLocationId, onSave }) => {
    const activeColorStyle = useMemo(() => getActiveColorStyle(activeColor), [activeColor]);
    const selectStyles = useMemo(
        () => getTheme2FormPageDarkSelectStyles(activeColorStyle, isTheme2),
        [activeColorStyle, isTheme2]
    );
    // Safety check - if formData is undefined, provide default values
    const safeFormData = formData || {};
    const updateSalesLocationMutation = useUpdateSalesLocation();

    // Local state for form data
    const [localFormData, setLocalFormData] = React.useState(formData || {});

    // Update local state when formData prop changes
    React.useEffect(() => {
        setLocalFormData(formData || {});
    }, [formData]);

    const saveInventoryDefaultsRef = React.useRef();

    // Function to save inventory defaults data
    const saveInventoryDefaults = React.useCallback(() => {
        if (salesLocationId && localFormData) {
            const updateData = {
                inventory_defaults: localFormData
            };

            updateSalesLocationMutation.mutate({
                id: salesLocationId,
                data: updateData
            });
        }
    }, [salesLocationId, localFormData, updateSalesLocationMutation]);

    // Update ref whenever saveInventoryDefaults changes
    React.useEffect(() => {
        saveInventoryDefaultsRef.current = saveInventoryDefaults;
    }, [saveInventoryDefaults]);

    // Call onSave callback when component mounts to register save function
    React.useEffect(() => {
        if (onSave) {
            onSave('INVENTORY_DEFAULTS', () => saveInventoryDefaultsRef.current?.());
        }
    }, [onSave]);


    return (
        <div className="">
            <Row>
                <Col md="6">
                    <FormGroup>
                        <Label className='form-control-label'>MMR Default Region:</Label>
                        <Select
                            activeColor={activeColor}
                            styles={selectStyles}
                            className="react-select"
                            value={localFormData.default_region?.mmr ? { value: localFormData.default_region.mmr, label: localFormData.default_region.mmr } : null}
                            onChange={(option) => {
                                const value = option?.value || '';
                                const updatedData = {
                                    ...localFormData,
                                    default_region: {
                                        ...(localFormData.default_region || {}),
                                        mmr: value
                                    }
                                };
                                setLocalFormData(updatedData);
                            }}
                            options={[
                                { value: 'N ational', label: 'National' },
                                { value: 'North Texas', label: 'North Texas' },
                                { value: 'South Texas', label: 'South Texas' },
                                { value: 'West Texas', label: 'West Texas' },
                                { value: 'East Texas', label: 'East Texas' }
                            ]}

                        />
                    </FormGroup>
                </Col>
            </Row>

            <h5 className="mb-3 mt-3">DEFAULT EXPENSE CLASS CODE</h5>
            <Row>
                <Col md="4">
                    <FormGroup>
                        <Label className='form-control-label'>Available:</Label>
                        <Select
                            activeColor={activeColor}
                            styles={selectStyles}
                            className="react-select"
                            value={localFormData.avaliable ? inventoryStatusOptions.find(opt => opt.value === localFormData.avaliable) : null}
                            onChange={(option) => {
                                const value = option?.value || '';
                                const updatedData = { ...localFormData, avaliable: value };
                                setLocalFormData(updatedData);
                            }}
                            options={inventoryStatusOptions}
                        />
                    </FormGroup>
                </Col>
                <Col md="4">
                    <FormGroup>
                        <Label className='form-control-label'>Evaluating:</Label>
                        <Select
                            activeColor={activeColor}
                            styles={selectStyles}
                            className="react-select"
                            value={localFormData.evaluating ? inventoryStatusOptions.find(opt => opt.value === localFormData.evaluating) : null}
                            onChange={(option) => {
                                const value = option?.value || '';
                                const updatedData = { ...localFormData, evaluating: value };
                                setLocalFormData(updatedData);
                            }}
                            options={inventoryStatusOptions}

                        />
                    </FormGroup>
                </Col>

                <Col md="4">
                    <FormGroup>
                        <Label className='form-control-label'>Not for Sale:</Label>
                        <Select
                            activeColor={activeColor}
                            styles={selectStyles}
                            className="react-select"
                            value={localFormData.not_for_sale ? inventoryStatusOptions.find(opt => opt.value === localFormData.not_for_sale) : null}
                            onChange={(option) => {
                                const value = option?.value || '';
                                const updatedData = { ...localFormData, not_for_sale: value };
                                setLocalFormData(updatedData);
                            }}
                            options={inventoryStatusOptions}

                        />
                    </FormGroup>
                </Col>
            </Row>
            <Row>

                <Col md="4">
                    <FormGroup>
                        <Label className='form-control-label'>Recon Detail:</Label>
                        <Select
                            activeColor={activeColor}
                            styles={selectStyles}
                            className="react-select"
                            value={localFormData.recon_detail ? inventoryStatusOptions.find(opt => opt.value === localFormData.recon_detail) : null}
                            onChange={(option) => {
                                const value = option?.value || '';
                                const updatedData = { ...localFormData, recon_detail: value };
                                setLocalFormData(updatedData);
                            }}
                            options={inventoryStatusOptions}

                        />
                    </FormGroup>
                </Col>

                <Col md="4">
                    <FormGroup>
                        <Label className='form-control-label'>Check In:</Label>
                        <Select
                            activeColor={activeColor}
                            styles={selectStyles}
                            className="react-select"
                            value={localFormData.check_in ? inventoryStatusOptions.find(opt => opt.value === localFormData.check_in) : null}
                            onChange={(option) => {
                                const value = option?.value || '';
                                const updatedData = { ...localFormData, check_in: value };
                                setLocalFormData(updatedData);
                            }}
                            options={inventoryStatusOptions}

                        />
                    </FormGroup>
                </Col>
                <Col md="4">
                    <FormGroup>
                        <Label className='form-control-label'>Repair/Service:</Label>
                        <Select
                            activeColor={activeColor}
                            styles={selectStyles}
                            className="react-select"
                            value={localFormData.repair_service ? inventoryStatusOptions.find(opt => opt.value === localFormData.repair_service) : null}
                            onChange={(option) => {
                                const value = option?.value || '';
                                const updatedData = { ...localFormData, repair_service: value };
                                setLocalFormData(updatedData);
                            }}
                            options={inventoryStatusOptions}

                        />
                    </FormGroup>
                </Col>
            </Row>

            <Row>
                <Col md="4">
                    <FormGroup>
                        <Label className='form-control-label'>Spot Delivered:</Label>
                        <Select
                            activeColor={activeColor}
                            styles={selectStyles}
                            className="react-select"
                            value={localFormData.spot_delivered ? inventoryStatusOptions.find(opt => opt.value === localFormData.spot_delivered) : null}
                            onChange={(option) => {
                                const value = option?.value || '';
                                const updatedData = { ...localFormData, spot_delivered: value };
                                setLocalFormData(updatedData);
                            }}
                            options={inventoryStatusOptions}

                        />
                    </FormGroup>
                </Col>
                <Col md="4">
                    <FormGroup>
                        <Label className='form-control-label'>Sold:</Label>
                        <Select
                            activeColor={activeColor}
                            styles={selectStyles}
                            className="react-select"
                            value={localFormData.sold ? inventoryStatusOptions.find(opt => opt.value === localFormData.sold) : null}
                            onChange={(option) => {
                                const value = option?.value || '';
                                const updatedData = { ...localFormData, sold: value };
                                setLocalFormData(updatedData);
                            }}
                            options={inventoryStatusOptions}

                        />
                    </FormGroup>
                </Col>
                <Col md="4">
                    <FormGroup>
                        <Label className='form-control-label'>Deleted:</Label>
                        <Select
                            activeColor={activeColor}
                            styles={selectStyles}
                            className="react-select"
                            value={localFormData.deleted ? inventoryStatusOptions.find(opt => opt.value === localFormData.deleted) : null}
                            onChange={(option) => {
                                const value = option?.value || '';
                                const updatedData = { ...localFormData, deleted: value };
                                setLocalFormData(updatedData);
                            }}
                            options={inventoryStatusOptions}

                        />
                    </FormGroup>
                </Col>
            </Row>
            <Row>
                <Col md="4">
                    <FormGroup>
                        <Label className='form-control-label'>On Hold:</Label>
                        <Select
                            activeColor={activeColor}
                            styles={selectStyles}
                            className="react-select"
                            value={localFormData.on_hold ? inventoryStatusOptions.find(opt => opt.value === localFormData.on_hold) : null}
                            onChange={(option) => {
                                const value = option?.value || '';
                                const updatedData = { ...localFormData, on_hold: value };
                                setLocalFormData(updatedData);
                            }}
                            options={inventoryStatusOptions}

                        />
                    </FormGroup>
                </Col>

                <Col md="4">
                    <FormGroup>
                        <Label className='form-control-label'>Pending Sale:</Label>
                        <Select
                            activeColor={activeColor}
                            styles={selectStyles}
                            className="react-select"
                            value={localFormData.pending_sale ? inventoryStatusOptions.find(opt => opt.value === localFormData.pending_sale) : null}
                            onChange={(option) => {
                                const value = option?.value || '';
                                const updatedData = { ...localFormData, pending_sale: value };
                                setLocalFormData(updatedData);
                            }}
                            options={inventoryStatusOptions}

                        />
                    </FormGroup>
                </Col>
                <Col md="4">
                    <FormGroup>
                        <Label className='form-control-label'>In Transit:</Label>
                        <Select
                            activeColor={activeColor}
                            styles={selectStyles}
                            className="react-select"
                            value={localFormData.in_transit ? inventoryStatusOptions.find(opt => opt.value === localFormData.in_transit) : null}
                            onChange={(option) => {
                                const value = option?.value || '';
                                const updatedData = { ...localFormData, in_transit: value };
                                setLocalFormData(updatedData);
                            }}
                            options={inventoryStatusOptions}

                        />
                    </FormGroup>
                </Col>
            </Row>

            <h5 className="mb-3 mt-3">FLOOR PLAN SETTINGS</h5>
            <Row>
                <Col md="6">
                    <FormGroup>
                        <Label className='form-control-label'>Auto Close Floor Plan on Sale:</Label>
                        <Select
                            activeColor={activeColor}
                            styles={selectStyles}
                            className="react-select"
                            value={localFormData.floor_plan_sale ? [
                                { value: 'yes', label: 'Yes' },
                                { value: 'no', label: 'No' }
                            ].find(opt => opt.value === localFormData.floor_plan_sale) : null}
                            onChange={(option) => {
                                const value = option?.value || '';
                                const updatedData = { ...localFormData, floor_plan_sale: value };
                                setLocalFormData(updatedData);
                            }}
                            options={[
                                { value: 'yes', label: 'Yes' },
                                { value: 'no', label: 'No' }
                            ]}

                        />
                    </FormGroup>
                </Col>
            </Row>
        </div>
    );
};

export default InventoryDefaults;
